import { z } from 'zod';
import { paginationQuery } from './common.js';
export const auditLogQuery = paginationQuery.extend({
    action: z.string().optional(),
    objectType: z.string().optional(),
    actorUserId: z.string().uuid().optional(),
});
//# sourceMappingURL=audit.js.map